<div>
  {{
    ((isCooperate$ | async) ? "common.corporate" : "common.general") | translate
  }}
</div>
